import { render } from "./ModalCovid.vue?vue&type=template&id=74b8134a"
import script from "./ModalCovid.vue?vue&type=script&lang=js"
export * from "./ModalCovid.vue?vue&type=script&lang=js"

import "./ModalCovid.vue?vue&type=style&index=0&id=74b8134a&lang=css"

import exportComponent from "D:\\DEV\\Actual\\SanElita\\elita_web_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__